export const noFootballQuery = {
  bool: {
    must_not: {
      term: {
        categoryGroupName: 'FOOTBALL',
      },
    },
  },
};
